<div *ngIf="this.display != null" [hidden]="status < 2" class="icon-container" [matTooltip]="this.statusMap.get(status)" matTooltipClass="type-tooltip">
  <ion-icon *ngIf="this.display.icon" [color]="this.display.color" [size]="this.size" [name]="this.display.icon"></ion-icon>
  <ion-img class="h-only" *ngIf="this.display.src" [src]="this.display.src"></ion-img>
</div>
<div [hidden]="status >= 2">
  {{ this.statusMap?.get(status) }}
</div>
